<div [ngClass]="{'capability-selected': capability.selected,'optional-capability': !capability.selected,'cursor-none': (!capability?.displayName && !capability?.name)}">
  <div class="flex flex-col capability-card p-24 h-200" [ngClass]="{'hoverColor': !capability.selected, 'selected': capability.selected, 'disabled': (!capability?.displayName && !capability?.name)}">
    <div class="flex justify-between mb-20">
      <div class="mat-headline-5 mb-0 max-limit-per-line">{{capability?.displayName ? (capability?.displayName) : ((capability?.name) ? (capability?.name | titlecase) : 'INSTANCE_SUMMARY.SERVICE_DEFINITION.NOT_AVAILABLE' | transloco) }}</div>
      <div *ngIf="selectable && permissionsMap[PermissionKeys.BLUEPRINT_CREATE]" class="items-end">
        <ng-container *ngIf="capability?.displayName || capability?.name; else disableSelection">
          <mat-icon *ngIf="!capability.selected" svgIcon="check_box_outline_blank" class="select-icon icon-md-1 cursor-pointer"
          (click)="toggleSelection()"></mat-icon>
          <mat-icon *ngIf="capability.selected" svgIcon="check_box" class="select-icon icon-md-1 cursor-pointer"
          (click)="!capability.disabled ? toggleSelection() : null"></mat-icon>
        </ng-container>
        <ng-template #disableSelection>
          <mat-icon svgIcon="check_box_outline_blank" [ngClass]="{'mb-80': !capability?.description}" class="select-icon icon-md-1 cursor-pointer disabled"></mat-icon>
        </ng-template>
      </div>
    </div>
    <ng-container *ngIf="(capability?.displayName || capability?.name) && capability?.description; else description">
      <div class="capabilties-description mat-body-2 mb-12 description fw-400">{{capability.description}}</div>
    </ng-container>
    <ng-template #description>
      <div *ngIf="capability?.description; else notavailableDescription" class="flex">
        <div class="flex-1 mb-12 capabilties-description mat-body-2 mb-12 description fw-400">{{capability.description}}</div>
      </div>
      <ng-template #notavailableDescription>
        <div class="flex-1 mb-12">
          {{'INSTANCE_SUMMARY.SERVICE_DEFINITION.NOT_AVAILABLE' | transloco}}
        </div>
      </ng-template>
    </ng-template>
    <button class="basic-button w-max-content capability-link mat-subtitle-2 fw-400 mt-10 mb-0 h-auto"
    (click)="viewDetails()">{{'CAPABILITIES.VIEW' | transloco}}</button>
  </div>
</div>
